import { useIntl } from 'react-intl';

import { FormMessage } from '@xing-com/crate-login-layout';

import { messages } from './messages';

type PartnerNoticeProps = {
  partner: {
    name: string;
    website: string;
  };
};

const partnerLink = (name: string, website: string): JSX.Element => (
  <a href={website} target="_blank" rel="noopener noreferrer">
    {name}
  </a>
);

export const PartnerNotice: React.FC<PartnerNoticeProps> = ({ partner }) => {
  const intl = useIntl();

  return (
    <FormMessage
      notice={intl.formatMessage(messages.partnerAuthIntroduction, {
        application: partnerLink(partner.name, partner.website),
      })}
    />
  );
};
